import { render, staticRenderFns } from "./DetailPermohonanPersetujuan.vue?vue&type=template&id=6c7c82ea&"
import script from "./DetailPermohonanPersetujuan.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanPersetujuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports